import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";
import { Loader2, ArrowRight } from "lucide-react";

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { setError("Password must be at least 6 characters."); return; }
    setLoading(true); setError("");
    const res = await register(name, email, password);
    setLoading(false);
    if (res.ok) navigate("/dashboard");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center container-px py-24" data-testid="register-page">
      <div aria-hidden className="fixed inset-0 grid-noise opacity-60 pointer-events-none -z-10" />
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex mb-10"><Logo /></Link>
        <div className="glass-card p-8">
          <div className="eyebrow text-gold-300">Create account</div>
          <h1 className="mt-2 font-serif text-3xl text-white">Join AIBoxHub</h1>
          <p className="mt-2 text-sm text-white/55">Start your free demo. No credit card required.</p>

          <form onSubmit={submit} className="mt-7 space-y-4">
            <Input testId="register-name" label="Full Name" value={name} onChange={setName} required />
            <Input testId="register-email" label="Email" type="email" value={email} onChange={setEmail} required />
            <Input testId="register-password" label="Password (min 6 chars)" type="password" value={password} onChange={setPassword} required />
            {error && <div className="text-sm text-red-400" data-testid="register-error">{error}</div>}
            <button type="submit" disabled={loading} className="w-full pill pill-gold justify-center disabled:opacity-50" data-testid="register-submit">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Create account <ArrowRight className="h-4 w-4" /></>}
            </button>
          </form>

          <div className="mt-6 text-sm text-white/55">
            Already have an account?{" "}
            <Link to="/login" className="text-gold-300 hover:text-gold-200" data-testid="register-to-login">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

function Input({ label, value, onChange, type = "text", required, testId }) {
  return (
    <div>
      <div className="mb-1.5 text-[11px] font-mono uppercase tracking-[0.2em] text-white/50">{label}</div>
      <input
        data-testid={testId}
        type={type}
        required={required}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full bg-ink-200 border border-white/10 rounded-xl px-4 py-3 text-sm text-white placeholder-white/30 outline-none focus:border-gold-500/50"
      />
    </div>
  );
}
